<template>
    <div>
<!--        The user <strong>{{ $_.get(activity, "payload.name") }}</strong> was added by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.userAdded', { newAgent: $_.get(activity, 'payload.name'), agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
